/**
 * Legacy-Redirect: /payouts → /settlements — Story 0.2 (v2-Relaunch)
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/payouts')({
  beforeLoad: () => {
    throw redirect({ to: '/settlements', replace: true })
  },
  component: () => null,
})
